




















import { Component, Prop, Model } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class UiRadio extends mixins(PlanLimitsMixin) {
  @Model('change')
  modelValue: any

  @Prop()
  color: string

  @Prop()
  click: (string)=>boolean; // if function exist and return true - it means stop do anything else after

  @Prop()
  value: any;

  @Prop({ default: '' })
  label: string;

  @Prop({ default: '' })
  helpTooltip: string;

  @Prop({ default: false })
  disabled: boolean;

  get colorStateChecked() {
    return this.color || (this.$parent as any).color || this.$colors.green
  }

  get disabledState() {
    return this.disabled || (this.$parent as any).disabled
  }

  get colorState () {
    if (this.disabledState) return this.$colors.gray40
    return this.isChecked ? this.colorStateChecked : this.$colors.gray40
  }

  get model() {
    return this.modelValue || (this.$parent as any).modelValue
  }

  set model(val) {
    if (this.modelValue) {
      this.$emit('change', val);
    }

    this.$parent.$emit('change', val);
  }

  get isChecked() {
    return this.model == this.value
  }

  get bottomSpace() {
    // if radio-group is inline
    if((this.$parent as any).styleType === 'inline') return
    return {
      marginBottom:'7px' // 12px in sum with line-height etc
    }
  }

  handleClick(e){
    if(this.showPlanLimitsIcon){
      e.preventDefault()
      return this.handleClickPlanLimits()
    }

    if(this.click?.(this.value)===true){
      e.preventDefault()
    }
  }
}
